"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceAreaEntity_1 = __importDefault(require("./Entity/ServiceAreaEntity"));
/**
 * @deprecated please use ServiceArea v2
 */
var ServiceAreaApi = /** @class */ (function () {
    function ServiceAreaApi(session) {
        this.serviceAreaEntity = new ServiceAreaEntity_1.default(session);
    }
    /**
     * @deprecated please use ServiceArea v2
     */
    ServiceAreaApi.prototype.getAll = function () {
        return this.serviceAreaEntity.service.getAll();
    };
    /**
     * @deprecated please use ServiceArea v2
     */
    ServiceAreaApi.prototype.getAllByTeams = function (request) {
        return this.serviceAreaEntity.service.getAll(request);
    };
    ServiceAreaApi.prototype.create = function (request) {
        return this.serviceAreaEntity.service.create(request);
    };
    ServiceAreaApi.prototype.update = function (id, request) {
        return this.serviceAreaEntity.service.update(id, request);
    };
    ServiceAreaApi.prototype.assign = function (id, request) {
        return this.serviceAreaEntity.assign(id, request);
    };
    ServiceAreaApi.prototype.unassign = function (request) {
        return this.serviceAreaEntity.unassign(request);
    };
    ServiceAreaApi.prototype.delete = function (id) {
        return this.serviceAreaEntity.service.delete(id);
    };
    return ServiceAreaApi;
}());
exports.default = ServiceAreaApi;
//# sourceMappingURL=ServiceAreaApi.js.map